<button (click)="showDialog()" mat-icon-button micro-button>
  <mat-icon>palette</mat-icon>
</button>
